import { Component, OnInit } from '@angular/core';
import {
  DetailSearchConfiguration,
  OmniApi,
  SearchRequest,
  SearchService,
  Session,
} from 'src/app/my-sedgwick';
import { PendingAccommodation } from 'src/app/my-sedgwick/models/accommodation';
import { BaseComponent, LoadingState } from 'src/app/shared';

@Component({
    selector: 'app-pending-accomodations-page',
    template: `
    <app-section>
      <div class="app-pl2 tw-w-full">
        <app-claim-breadcrumb></app-claim-breadcrumb>
      </div>
      <app-panel
        title="Pending Accommodations"
        [headerLevel]="1"
        class="tw-w-full"
        [canExpand]="false"
      >
        <div class="tw-min-h-[510px] tw-w-full">
          <app-detail-search-form
            #searchForm
            [config]="config"
            (search)="search($event)"
            [loading]="loading"
          >
            <ng-template #results>
              <app-search-count-row
                resultPlural="results"
                [count]="pendingAccommodations.length"
                [isInDirectInclude]="isInDirectReporting"
                [isSupervisor]="isSupervisorSelect"
                [supervisorFullName]="SupervisorFullName"
              ></app-search-count-row>
              <app-pending-accommodations
                [accomodations]="pendingAccommodations"
                class="tw-w-full"
                excelName="Pending Accommodations"
                sheetName="Pending Accommodations"
                (export)="searchForm.appendExport($event)"
              >
              </app-pending-accommodations>
            </ng-template>
          </app-detail-search-form>
        </div>
      </app-panel>
    </app-section>
  `,
    styles: [``],
    standalone: false
})
export class PendingAccomodationsPageComponent
  extends BaseComponent
  implements OnInit
{
  config = new DetailSearchConfiguration();
  loading: LoadingState;
  pendingAccommodations: PendingAccommodation[];
  isSupervisorSelect : boolean = false;
  SupervisorFullName : string = '';
  isInDirectReporting : boolean = false;

  constructor(private OmniApi: OmniApi, private searchService: SearchService, private session:Session) {
    super();
    this.config.key = 'omni-dashboard:pending-accommodations';
    this.config.ssn.visible = false;
    this.config.status.visible = false;
    this.config.lob.visible = false;
    this.config.supervisor.visible = false;
    this.config.includeIndirect.visible = false;
    this.config.startDate.visible = false;
    this.config.endDate.visible = false;
    this.config.employeeId.widthPercent = 25;
    this.config.initialSearch = true;
    this.config.initialSearchResultsOnClear = true;
    this.config.managerLookupSupervisor = false;
    this.config.showParametersToggle = true;
    this.config.expanded = false;
    this.config.payType.visible = false;
    this.config.maxBackDays = 30;
  }

  ngOnInit(): void {
    this.config.startDate.widthPercent = 25;
    this.config.endDate.widthPercent = 25;

    if(this.verifyFilterByManager())
    {
      this.isSupervisorSelect = this.verifyFilterByManager();
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      this.SupervisorFullName = supervisor.name;
      this.isInDirectReporting = this.verifyIndirectReport();
    }

  }

   verifyIndirectReport() {
    const includeIndirectsInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'includeIndirects_summary'
    );

    if (includeIndirectsInSession == undefined || includeIndirectsInSession == null || includeIndirectsInSession.length < 2) {
      return false;
    }
    else {
      return includeIndirectsInSession == 'true';
    }
  }
  verifyFilterByManager() {
    const filteredManagerInSession = sessionStorage.getItem(
      this.session.user.sessionId + 'filteredManager_summary'
    );

    if (filteredManagerInSession == undefined || filteredManagerInSession == null || filteredManagerInSession.length < 2) {
      return false;
    }
    else {
      return true;
    }
  }

  override ngOnDestroy(): void {
    this.config.initialSearch = true;
  }

  async search(request: SearchRequest) {
    this.loading = 'Loading';

    const params = request.getParameters();
    params.status = ['O'];
    params.lob = ['AD'];
    params.excludeSupervisor = true;     
   
    if(this.verifyFilterByManager())
    {      
       const filteredManagerInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'filteredManager_summary');
      const supervisor = JSON.parse(filteredManagerInSession);
      params.supervisor = supervisor;
      params.managerEmpUnum = supervisor.empUnum;
    }
    else{
      params.supervisor = null;
      params.managerEmpUnum = null;
    }

     if (this.verifyIndirectReport()) {
      const includeIndirectsInSession = sessionStorage.getItem(
        this.session.user.sessionId + 'includeIndirects_summary'
      );
      params.includeIndirectReports = includeIndirectsInSession.toLowerCase() == 'true';
    }
    else {
      params.includeIndirectReports = false;
    }
    
    const searchInformation =
      await this.OmniApi.getPendingAccomodationsJobFunctions(params);
    this.config.initialSearch = false;
    this.pendingAccommodations = searchInformation;
    this.loading = this.pendingAccommodations.length > 0 ? 'Loaded' : 'Empty';
  }
}
